import React from "react";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";

import git from "../../assets/git.png";
import github from "../../assets/github.svg";
import html from "../../assets/html.png";
import javascript from "../../assets/javascript.png";
import mongo from "../../assets/mongodb.png";
import react from "../../assets/react.png";
import cpp from "../../assets/cpp.png";
import css from "../../assets/css.png";
import linux from "../../assets/linux.png";
import mysql from "../../assets/mysql.png";
import sass from "../../assets/sass.png";
import express from "../../assets/express.png";
import next from "../../assets/nextjs.svg";
import aws from "../../assets/aws.png";
import firebase from "../../assets/firebase.png";

import "./Skills.scss";

function Skills() {
  const experiences = [
    {
      year: 2021,
      works: [
        {
          name: "Junior Developer",
          company: "GDSC IIIT Surat",
          desc: "June'21 - April'22",
        },
      ],
    },
    {
      year: 2022,
      works: [
        {
          name: "Back-End Developer",
          company: "Technoboot Pvt. Ltd",
          desc: "June'22 - Aug'22",
        },
        {
          name: "Core Team Member",
          company: "GDSC IIIT Surat",
          desc: "Aug'22 - present",
        },
        {
          name: "Attended & Prize Pooled",
          company: "Asia's Largest Ethereum Hackathon, EthIndia'22, Bengaluru",
          desc: "Dec'22",
        },
      ],
    },
    {
      year: 2023,
      works: [
        {
          name: "Ranked 1st",
          company: "Cognizance'23 Blockathon, IIT Roorkee",
          desc: "March'23",
        },
        {
          name: "Ranked 2nd",
          company: "Central India'a Largest E-Summit, NIT BHOPAL",
          desc: "Feb'23",
        },
        {
          name: "Technical Writer",
          company: "GeeksforGeeks",
          desc: "July'23 - present",
        },
        {
          name: "Blockchain Developer",
          company: "Hooman Digital LLP",
          desc: "July'23 - Sept'23",
        }
      ],
    },
  ];
  const skills = [
    { name: "C++", icon: cpp },
    { name: "Git", icon: git },
    { name: "Github", icon: github },
    { name: "HTML", icon: html },
    { name: "CSS", icon: css },
    { name: "SASS", icon: sass },
    { name: "Javascript", icon: javascript },
    { name: "MongoDB", icon: mongo },
    { name: "MySQL", icon: mysql },
    { name: "Firebase", icon: firebase },
    { name: "ReactJS", icon: react },
    { name: "NextJS", icon: next },
    { name: "ExpressJS", icon: express },
    { name: "Linux", icon: linux },
    { name: "AWS", icon: aws },
  ];

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.2 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
